<template>
  <div class="inspectiondetail--header">
    <HeroImage
      :hg-report-cover-image="inspection.defaultCoverImage"
      class="inspectiondetail--header-hero" />

    <div class="inspectiondetail--header-content">
      <AddressTitleBar
        :hg-address="inspectionStreetAddress"
        :hg-location="inspectionLocation"
        :hg-inspection-page="true"
        :hg-logo="companyLogo"
        class="inspectiondetail--header-title title">

        <ReportButton
          id="report-button"
          :hg-folder-id="folderId"
          :hg-primary-report="primaryInspectionReport"
          :hg-report-block="isBlocked" />

        <AllReportsAnchor
          :hg-report-anchor="reportAnchor"
          :hg-report-block="isBlocked"
          :hg-report-count="reportsCount" />
      </AddressTitleBar>

      <NewReportAlert
        :hg-new-report-info="newReportInfo"
        :hg-report-anchor="reportAnchor"
        :hg-report-block="isBlocked" />
    </div>
  </div>
</template>

<script>
import { Mixins } from '@homegauge/vue';
import { mapGetters, mapState } from 'vuex';

import AddressTitleBar from '@/components/AddressBar/AddressTitleBar.vue';
import AllReportsAnchor from '@/components/AddressBar/AllReportsAnchor.vue';
import ReportButton from '@/components/AddressBar/ReportButton.vue';
import HeroImage from './HeroImage.vue';
import NewReportAlert from './NewReportAlert.vue';

const { DateTime } = Mixins;

export default {
  components: {
    AddressTitleBar,
    AllReportsAnchor,
    HeroImage,
    NewReportAlert,
    ReportButton,
  },
  mixins: [DateTime],
  props: {
    folderId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reportAnchor: 'report-anchor',
    };
  },
  computed: {
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    ...mapGetters('Inspection', [
      'inspectionLatestUnviewedReports',
      'inspectionStreetAddress',
      'inspectionLocation',
      'inspectionUnviewedReports',
      'inspectionUnviewedReportsLatestDate',
      'primaryInspectionReport',
    ]),
    companyLogo() {
      return this.inspection.company
        ? this.inspection.company.companyLogo
        : '';
    },
    isBlocked() {
      return this.inspection.folderStatus
        ? !!(this.inspection.folderStatus.blocked)
        : false;
    },
    reportsCount() {
      return this.inspection.reports
        ? this.inspection.reports.length
        : 0;
    },
    newReportInfo() {
      const output = {
        mostRecentUnviewedCount: 0,
        mostRecentUnviewedDate: this.dotDate(new Date()),
        totalReportCount: 0,
        unviewedReportCount: 0,
      };

      // early return default values if there are no reports
      if (!this.inspection || !this.inspection.reports) {
        return output;
      }

      output.totalReportCount = this.inspection.reports.length;
      if (this.inspectionLatestUnviewedReports) {
        output.mostRecentUnviewedCount = this.inspectionLatestUnviewedReports.length;
      }
      if (this.inspectionUnviewedReportsLatestDate) {
        output.mostRecentUnviewedDate = this.dotDate(this.inspectionUnviewedReportsLatestDate);
      }
      if (this.inspectionUnviewedReports) {
        output.unviewedReportCount = this.inspectionUnviewedReports.length;
      }

      return output;
    },
  },
};
</script>

<style lang="scss" scoped>
.inspectiondetail--header {
  &-content {
    position: relative;
    z-index: 2;
  }

  &-hero {
    position: relative;
    z-index: 1;
  }
}

@media all and (max-width: 655px) {
  .inspectiondetail--header {
    &-content {
      margin: -55px 0 0;
    }

    &-title {
      margin-bottom: 20px;
      top: -55px;
    }
  }
}
</style>
